import HBButton from "@/components/HBButton";
import { BoardPinList } from "@/pageComponents/BoardPinList/PinList";
import Link from "next/link";
import styles from "./index.module.less";

export default function UnorganizedPinList({
  board,
  showEditBtn = false,
}: {
  board: IBoardInfo;
  showEditBtn?: boolean;
}) {
  return (
    <div className={styles.unorganizedContainer}>
      <div className={styles.title}>
        待整理的灵感
        {showEditBtn && (
          <Link href={`/boards/edit/${board.board_id}`}>
            <a
              data-gd-click="button_click"
              data-button-name="整理"
              data-content-source="待整理的灵感"
            >
              <HBButton> 整理 </HBButton>
            </a>
          </Link>
        )}
      </div>
      <div className={styles.content} data-content-source="待整理的灵感">
        <BoardPinList board={board} />
      </div>
    </div>
  );
}
